export default {
  namespaced: true,
  employees_units: {
    title: 'Atribuição de funcionários | Atribuição de funcionário',
    schedules: 'Horário',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    sunday: 'Domingo',
    start: 'Entrada',
    end: 'Saída',
    startRequired: 'Início necessário',
    endRequired: 'Fim necessário'
  }
}
